import React, { Component } from "react";
import { SearchVehicleFeatures } from "../../organisms";

export class SearchPage extends Component {
  render() {
    return <SearchVehicleFeatures />;
  }
}
